import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const num = (v) => (v === "" ? null : Number(v));

export const IncomeTaxEditor = ({ t, onChange, prefix = "review" }) => {
  const v = t || { brackets: [], levy_rate: null, levy_note: "", note: "", url: "" };
  const set = (k, x) => onChange({ ...v, [k]: x });
  const setRow = (i, k, x) => set("brackets", v.brackets.map((b, j) => (j === i ? { ...b, [k]: num(x) } : b)));
  return (
    <div className="space-y-2" data-testid={`${prefix}-income-tax`}>
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Personal income tax rates (used for members' budget share estimate)</p>
      {v.brackets.map((b, i) => (
        <div key={i} className="flex items-center gap-2 text-xs text-slate-500">
          Over<Input type="number" value={b.over ?? ""} onChange={(e) => setRow(i, "over", e.target.value)} className="w-32 bg-white text-slate-900" data-testid={`${prefix}-bracket-over-${i}`} />
          taxed at<Input type="number" value={b.rate ?? ""} onChange={(e) => setRow(i, "rate", e.target.value)} className="w-20 bg-white text-slate-900" data-testid={`${prefix}-bracket-rate-${i}`} />%
          <Button type="button" size="icon" variant="ghost" aria-label="Remove bracket" onClick={() => set("brackets", v.brackets.filter((_, j) => j !== i))} data-testid={`${prefix}-bracket-remove-${i}`}><Trash2 size={15} /></Button>
        </div>))}
      <Button type="button" size="sm" variant="ghost" className="rounded-full" onClick={() => set("brackets", [...v.brackets, { over: null, rate: null }])} data-testid={`${prefix}-bracket-add`}><Plus size={14} className="mr-1" />Add bracket</Button>
      <div className="grid gap-3 sm:grid-cols-4">
        {[["levy_rate", "Flat levy on all income (%)", "number"], ["levy_note", "Levy name, e.g. 2% Medicare levy"], ["note", "Who the rates apply to"], ["url", "Official rates link"]].map(([k, label, type]) => (
          <label key={k} className="block text-xs text-slate-500">{label}<Input type={type || "text"} value={v[k] ?? ""} onChange={(e) => set(k, type ? num(e.target.value) : e.target.value)} className="mt-1 bg-white text-slate-900" data-testid={`${prefix}-income-tax-${k}`} /></label>
        ))}
      </div>
    </div>
  );
};
